import React from "react";
import "./armont.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import fasarmont from "../../../asset/fascarousel/fas-armont/fas-armont.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import imgArmont8 from "../../../asset/imgrumah/img-armont/img-armont8/img-armont8.js";
import imgArmont9 from "../../../asset/imgrumah/img-armont/img-armont9/img-armont9.js";
import imgArmont10 from "../../../asset/imgrumah/img-armont/img-armont10/img-armont10.js";
import imgMonard8 from "../../../asset/imgrumah/img-armont/img-monard8/img-monard8.js";
import imgMonard9 from "../../../asset/imgrumah/img-armont/img-monard9/img-monard9.js";
const imgMap = {
  fasarmont,
};
const imageMap = {
  imgArmont8,
  imgArmont9,
  imgArmont10,
  imgMonard8,
  imgMonard9,
};

const armont = () => {
  return (
    <div className="armont">
      <div className="hero">
        {data.armontab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.armontab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Armont.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasArmont.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div id="armont" className="devider">
        <div className="a">ARMONT</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Armontp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div id="monard" className="devider">
        <div className="a">MONARD</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Monardp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default armont;
